// Angular Imports
import { NgModule } from '@angular/core';

// This Module's Components
import { BizGridComponent } from './biz-grid.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { BizDatatableModule } from '../biz-datatable/biz-datatable.module';
import { PagesContainersModule } from '../../../../../containers/pages/pages.containers.module';
import { NgApexchartsModule } from 'ng-apexcharts';

@NgModule({
    imports: [
        FormsModule, ReactiveFormsModule, CommonModule, BizDatatableModule, PagesContainersModule,NgApexchartsModule
    ],
    declarations: [
        BizGridComponent,
    ],
    exports: [
        BizGridComponent,
    ]
})
export class BizGridModule {

}
